import LoginSvg from '../../../assets/login.svg?react';
import { IconProps } from '../../types/IconProps';

export function Login({ size = 20, ...props }: IconProps) {
  return <LoginSvg data-testid="login-icon" width={size} height={size} {...props} />;
}

export default Login;
